import { render, staticRenderFns } from "./SubSystemForm.vue?vue&type=template&id=5b9403cf&"
import script from "./SubSystemForm.vue?vue&type=script&lang=js&"
export * from "./SubSystemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports